document.addEventListener("DOMContentLoaded", function () {
   const tabs = document.querySelectorAll(".mtm-orders__tab");
   const contents = document.querySelectorAll(".mtm-orders__content");
   const nutriValues = document.querySelectorAll(".mtm-orders__detail-value--nutri");

   const formatNutriValue = (value) => {
      if (!value) {
         return "";
      }

      return value
         .split("/")
         .map((segment) => segment.trim())
         .filter(Boolean)
         .map((segment) => {
            const match = segment.match(/^([^\d]+?)(\d+)$/);

            if (!match) {
               return segment;
            }

            return `${match[1].trim()} x ${match[2]}`;
         })
         .join(" / ");
   };

   nutriValues.forEach((element) => {
      element.textContent = formatNutriValue(element.textContent.trim());
   });

   tabs.forEach((tab) => {
      tab.addEventListener("click", function () {
         const tabName = this.getAttribute("data-tab");

         // Update active tab
         tabs.forEach((t) => t.classList.remove("mtm-orders__tab--active"));
         this.classList.add("mtm-orders__tab--active");

         // Update active content
         contents.forEach((content) => content.classList.remove("mtm-orders__content--active"));
         document.querySelector(`[data-content="${tabName}"]`).classList.add("mtm-orders__content--active");
      });
   });
});
